import React, { memo, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { CgSpinnerTwo } from "react-icons/cg";
import { useDispatch } from "react-redux";

import { BellIcon } from "@/Components/Icons/BellIcon";
import CloseIcon from "@/Components/Icons/CloseIcon";
import {
  markNotificationAsRead,
  fetchNotificationHistory,
} from "@/reducers/clientnotification";
import { getNotificationLink, handleAPICatch } from "@/utilities/utils";

import { fetchUpcomingBookings } from "../../../../../reducers/clientdashboard";
import { _notificationHistory } from "../../../../../services/clientnotification";

const NotificationAlert = memo(({ t, live_notifications }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { note_id, message, msgLink, msg_type } = live_notifications;

  useEffect(() => {
    if (msg_type === "candidate_running_late") {
      dispatch(
        fetchUpcomingBookings({
          for_upcomming: 0,
        }),
      );
      dispatch(fetchNotificationHistory({}));
    }
  }, [msg_type, dispatch]);

  const handleNotificationClick = async (e) => {
    const preventRedirect =
      e.target.getAttribute("data-prevent") ||
      e.target.closest("[data-prevent]")?.getAttribute("data-prevent");

    if (preventRedirect === "redirect" || loading) return;

    setLoading(true);

    try {
      const res = await _notificationHistory({ notification_id: note_id });
      const notification = res.data.notification_history[0];
      const {
        created_at,
        elapsed_time,
        encrypted_id,
        id,
        is_read,
        link,
        message,
        notification_type,
      } = notification;

      if (notification_type === "mailshot_notification") {
        toast.dismiss(t.id);
        return;
      }

      const url = getNotificationLink(notification_type, encrypted_id, link);
      dispatch(markNotificationAsRead({ id }));
      toast.dismiss(t.id);
      window.open(url, "_blank");
    } catch (error) {
      handleAPICatch(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={`${t.visible ? "animate-enter" : "animate-leave"} pointer-events-auto relative w-full max-w-md cursor-pointer rounded-lg border border-primary bg-white p-3`}
      onClick={handleNotificationClick}
    >
      {loading ? (
        <div className="absolute left-0 top-0 flex h-full w-full items-center justify-center bg-black-100 text-primary">
          <CgSpinnerTwo className="animate-spin" />
        </div>
      ) : null}

      <div
        className={`duration-400 flex transition-all ease-linear ${loading ? "blur-sm" : ""}`}
      >
        <div className="flex-1">
          <div className="flex items-start gap-3">
            <div className="flex h-10 w-10 items-center justify-center text-[20px] text-primary">
              <BellIcon cls="w-[24px] h-[24px]" />
            </div>
            <div className="flex-1">
              <h4
                className="text-base font-semibold capitalize text-txtDark"
                dangerouslySetInnerHTML={{
                  __html:
                    msg_type === "mailshot_notification"
                      ? msgLink.replaceAll("_", " ")
                      : msg_type.replaceAll("_", " "),
                }}
              ></h4>
              <p
                className="line-clamp-2 pr-3 text-sm font-medium text-txtColor"
                dangerouslySetInnerHTML={{ __html: message }}
              ></p>
            </div>
          </div>
        </div>
        <div className="flex items-start">
          <button
            onClick={() => toast.dismiss(t.id)}
            className="text-indigo-600 hover:text-indigo-500 focus:ring-indigo-500 flex h-[30px] w-[30px] items-center justify-center border-0 text-sm font-medium focus:outline-none focus:ring-2"
            data-prevent="redirect"
          >
            <CloseIcon />
          </button>
        </div>
      </div>
    </div>
  );
});

NotificationAlert.displayName = "NotificationAlert";

export default NotificationAlert;
